/* eslint-disable no-shadow, react/sort-comp, consistent-return */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { canUseDOM } from 'exenv';
import Video from 'react-jw-player';
import axios from 'axios';
import GoogleIMAGenerator from '../video_module/utils/video_module_ads';
import get from 'lodash/get';
import RelatedSlider from '../related_slider/related_slider';

let ifvisible = false;
let scriptjs = false;

if (canUseDOM) {
  scriptjs = require('scriptjs');       // eslint-disable-line
  ifvisible = require('ifvisible.js');  // eslint-disable-line
}

export default class VideoMegatron extends Component {
  constructor(props) {
    super(props);

    this.state = {
      video: null,
      userIsActive: true,
      adDataForMoat: null,
      calledMoatEventTrackerMarker: {},
      currentVideo: null,
      currentVideoCategory: null,
      currentVideoTitle: null,
      currentVideoDescription: null
      // toggleState: false
    };

    this.player = null;
    this.MoatApiReference = null;
    this.videoContainerRef = React.createRef();

    this.onReady = this.onReady.bind(this);
    this.clickOverlay = this.clickOverlay.bind(this);
    this.setMoatTracking = this.setMoatTracking.bind(this);
    this.handleVideoSelection = this.handleVideoSelection.bind(this);
    this.trackMoatVideoProgress = this.trackMoatVideoProgress.bind(this);
    this.handleVideoCardClick = this.handleVideoCardClick.bind(this);
    this.renderCustomVideoPlaylist = this.renderCustomVideoPlaylist.bind(this);
  }

  componentDidMount() {
    const customEndpoint = get(this.props, 'endPt', false);
    let endPoint = '';
    if (customEndpoint) {
      endPoint = customEndpoint;
    } else {
      endPoint = `//cdn.jwplayer.com/v2/playlists/${
        this.props.playlist
      }?search=fastcompany.com`;
    }

    axios(endPoint).then(res => {
      this.setState(
        {
          video: res.data,
          currentVideo: res.data.playlist[0].mediaid
        },
        () => {
          if (scriptjs) {
            scriptjs(
              'https://z.moatads.com/jwplayerplugin0938452/moatplugin.js'
            );

            // Set up activity tracker, 10s = idle
            if (ifvisible) {
              ifvisible.setIdleDuration(10);
              ifvisible.on('idle', () => {
                this.setState({
                  userIsActive: false
                });
              });

              ifvisible.on('wakeup', () => {
                this.setState({
                  userIsActive: true
                });
              });
            }
          }
        }
      );
    });
  }

  componentWillUnmount() {
    if (canUseDOM) {
      if (window.moatjw) {
        window.moatjw.removeAll();
      }

      if (ifvisible) {
        ifvisible.off();
      }
    }
  }

  onReady() {
    this.player = window.jwplayer('video-megatron');
    const caption = this.player.getMute() ? 1 : 0;

    this.player.setCurrentCaptions(caption);

    this.player.on('playlistItem', () => {
      this.customVideoMetadata = {
        playerDimensions: `${this.player.getContainer().offsetWidth}x${
          this.player.getContainer().offsetHeight
        }`,
        abgroup: window?._ash?.requestAbGroup // eslint-disable-line no-underscore-dangle
      };

      // Initialize play positions
      this.lastKnownPlaybackPosition = 0;
      this.lastSystemClock = 0;
      this.playSent = false;
    });

    this.player.on('beforePlay', () => {
      if (this.player.getPosition() === 0) {
        if (!this.sessionStarted) {
          this.sessionStarted = true;
        }
      }
    });

    this.player.on('firstFrame', () => {
      if (!this.playSent) {
        this.PlaySent = true;
      }
    });

    this.player.on('time', data => {
      const d = new Date();

      this.lastSystemClock = d.getTime();
      this.lastKnownPlaybackPosition = data.position;

      const percentPlayed = Math.floor(data.position * 100 / data.duration);
      const marker = {};

      switch (percentPlayed) {
        case 1:
          if (!this.state.calledMoatEventTrackerMarker.AdVideoStart) {
            this.trackMoatVideoProgress('AdVideoStart', this.player, data);
            marker.AdVideoStart = true;
            this.setState({
              calledMoatEventTrackerMarker: marker
            });
          }
          break;
        case 25:
          if (!this.state.calledMoatEventTrackerMarker.AdVideoFirstQuartile) {
            this.trackMoatVideoProgress(
              'AdVideoFirstQuartile',
              this.player,
              data
            );
            marker.AdVideoFirstQuartile = true;
            this.setState({
              calledMoatEventTrackerMarker: marker
            });
          }
          break;
        case 50:
          if (!this.state.calledMoatEventTrackerMarker.AdVideoMidpoint) {
            this.trackMoatVideoProgress('AdVideoMidpoint', this.player, data);
            marker.AdVideoMidpoint = true;
            this.setState({
              calledMoatEventTrackerMarker: marker
            });
          }
          break;
        case 75:
          if (!this.state.calledMoatEventTrackerMarker.AdVideoThirdQuartile) {
            this.trackMoatVideoProgress(
              'AdVideoThirdQuartile',
              this.player,
              data
            );
            marker.AdVideoThirdQuartile = true;
            this.setState({
              calledMoatEventTrackerMarker: marker
            });
          }
          break;
        case 99:
          if (!this.state.calledMoatEventTrackerMarker.AdVideoComplete) {
            this.trackMoatVideoProgress('AdVideoComplete', this.player, data);
            marker.AdVideoComplete = true;
            this.setState({
              calledMoatEventTrackerMarker: marker
            });
          }
          break;
        default:
          break;
      }

      this.player.on('adTime', data => {
        const d = new Date();
        this.lastSystemClock = d.getTime();
        this.lastKnownPlaybackPosition = data.position;
      });

      this.player.on('seek', () => {});

      this.player.on('seeked', () => {
        this.lastKnownPlaybackPosition = this.player.getPosition(); // Save last known position
      });

      this.player.on('pause', e => {
        this.trackMoatVideoProgress('AdPaused', this.player, e);
      });

      this.player.on('play', e => {
        if (this.adsPlaying) {
          this.adsPlaying = false;
        }

        this.trackMoatVideoProgress('AdPlaying', this.player, e);
      });

      this.player.on('complete', () => {
        if (this.adsPlaying) {
          this.adsPlaying = false;
        }

        this.resetSession();

        if (!this.state.userIsActive) {
          this.player.stop();
        }

        if (!this.state.userIsActive) {
          this.player.stop();
        }
      });

      this.player.on('buffer', () => {});

      this.player.on('bufferFull', () => {});

      this.player.on('error', () => {
        this.resetSession();
      });

      this.player.on('setupError', () => {
        this.resetSession();
      });

      this.player.on('adImpression', data => {
        const adTitle = get(data, 'adtitle', 'unknown-title');
        const adWrapperCreativeId = get(
          data,
          'ima.ad.g.adWrapperCreativeIds[0]',
          'unknown-wrapper-creative-id'
        );
        const adWrapperId = get(
          data,
          'ima.ad.g.adWrapperIds[0]',
          'unknown-wrapper-id'
        );
        const adCreativeId = get(
          data,
          'ima.ad.g.creativeId',
          'unknown-creative-id'
        );
        const adName = `${adTitle} | ${adWrapperCreativeId} | ${adWrapperId} | ${adCreativeId}`;

        this.adStartBreak(
          adName,
          this.adPosition,
          this.lastKnownPlaybackPosition
        );

        if (!this.playSent) {
          this.playSent = true;
        }

        this.adsPlaying = true;
      });

      this.player.on('adPlay', () => {
        if (!this.playSent) {
          this.playSent = true;
        }
      });

      this.player.on('adStarted', () => {});

      this.player.on('adSkipped', () => {
        this.adsPlaying = false;
      });

      this.player.on('adComplete', () => {});

      this.player.on('adBreakEnd', () => {
        if (this.adsPlaying) {
          this.adsPlaying = false;
        }
      });

      this.player.on('remove', () => {
        if (this.sessionStarted) {
          this.resetSession();
        }
      });

      // this.player.on('adRequest', ad => {
      //   console.log('[ads] === video_megatron player.on adRequest', ad);
      //   const adDataDFP = get(ad, 'ima.ad.g');
      //   const { adId, creativeId, title } = adDataDFP;

      //   const adDataForMoat = {
      //     level1:
      //       get(adDataDFP, 'advertiserName', `advertiser for unit: ${title}`) ||
      //       `advertiser for unit: ${title}`,
      //     level2: title,
      //     level3: adId,
      //     level4: creativeId,
      //     slicer1: 'fastcompany',
      //     slicer2: creativeId
      //   };

      //   this.setState({
      //     adDataForMoat,
      //     calledMoatEventTrackerMarker: {}
      //   });
      //   this.MoatApiReference = null;
      // });
    });

    this.setMoatTracking(this.player);
  }

  setMoatTracking(player) {
    if (canUseDOM) {
      if (window.moatjw) {
        player.on('adImpression', event => {
          window.moatjw.add({
            partnerCode: 'mansuetojwint127635890115',
            player,
            adImpressionEvent: event
          });
        });
      }
    }
  }

  resetSession() {
    this.sessionStarted = false; // Will need to reinitialize for next video
    this.playSent = false;
  }

  adStartBreak() {
    if (!this.adsPlaying) {
      this.adsPlaying = true;
      this.adPosition = 0;
    } else {
      this.adPosition = this.adPosition + 1; // Just increase the adPosition value
    }
  }

  trackMoatVideoProgress(eventType, player, e) {
    const MoatTrackingPartnerCode = 'mansuetojwcontent613342534978';
    if (!this.MoatApiReference) {
      this.MoatApiReference = window.initMoatTracking(
        this.videoContainerRef.current,
        this.state.adDataForMoat,
        e.duration,
        MoatTrackingPartnerCode,
        null
      );
    }

    this.MoatApiReference.dispatchEvent({
      type: eventType,
      adVolume: player.getMute() ? 0 : (player.getVolume() / 100).toFixed(1)
    });
  }

  clickOverlay() {
    document.querySelector('.video-overlay').classList.add('hide');
    document.querySelector('.video-info').classList.add('hide');
    this.player.play();
  }

  handleVideoSelection(id, category, title, description) {
    if (this.state.currentVideo === id) return false;

    this.setState(
      {
        currentVideo: id,
        currentVideoCategory: category,
        currentVideoTitle: title,
        currentVideoDescription: description
      },
      () => {
        this.player.load(`//fc-api.fastcompany.com/api/v1/jw-feed/${id}`);
        this.resetSession();
        // this.player.play();
      }
    );
  }

  handleVideoCardClick(post) {
    const id = get(post, 'id', '');
    const category = get(post, 'category', '');
    const title = get(post, 'title', '');
    const description = get(post, 'description', '');
    this.handleVideoSelection(id, category, title, description);
  }

  renderCustomVideoPlaylist(playlist) {
    // eslint-disable-next-line react/prop-types
    const { customConfig } = this.props;
    return [
      <RelatedSlider
        key={playlist.feedid}
        title={playlist.title || 'none'}
        related={playlist.playlist}
        slug={playlist.slug || 'slug missing'}
        classNames={['related-slider--video-index', 'custom']}
        slideClassNames={['video-slide--horizontal-tight']}
        config={customConfig}
        playlistId={playlist.feedid}
        noLink={true}
        sliderCardClicked={this.handleVideoCardClick}
        responsive={[
          {
            breakpoint: 640,
            settings: {
              slidesToShow: 2.15,
              slidesToScroll: 2
            }
          },
          {
            breakpoint: 100000,
            settings: {
              slidesToShow: 4,
              slidesToScroll: 4
            }
          }
        ]}
      />
    ];
  }

  render() {
    if (!this.state.video) return false;
    const firstVideo = get(this.state, 'video.playlist[0]', null);
    const title = get(firstVideo, 'title', '');
    const description = get(firstVideo, 'description', '');
    const category = get(firstVideo, 'category', '');
    return (
      <section className={`video-megatron ${this.props.endPt ? 'custom' : ''}`}>
        <div className="video-player-wrapper">
          <div className="video-player" ref={this.videoContainerRef}>
            <Video
              playerId="video-megatron"
              playerScript="https://content.jwplatform.com/libraries/S002m6Rz.js"
              playlist={`//fc-api.fastcompany.com/api/v1/jw-feed/${
                this.state.currentVideo
              }`}
              generatePrerollUrl={function generatePreRoll(video) {
                return new GoogleIMAGenerator(video, 'videotagpage').adTag;
              }}
              isAutoPlay={false}
              playInView={false}
              onClick={() => {
                // this.clickOverlay();
              }}
              onReady={this.onReady}
              onAdPlay={function reactJWPlayerOnAdPlay(event) {
                if (window.moatjw) {
                  window.moatjw.add({
                    partnerCode: 'mansuetojwint127635890115',
                    player: window.jwplayer(this.playerId),
                    adImpressionEvent: event
                  });
                }
              }}
              playInViewPercentage={100}
              className="jwplayer--video-post"
            />

            <div className="video-overlay">
              <div
                className="play-button"
                onClick={() => {
                  this.clickOverlay();
                }}
              >
                <img
                  src="//images.fastcompany.net/image/upload/v1602728950/fcweb/play-icon-btn-large_et4asc.svg"
                  alt="play"
                />
              </div>
            </div>
          </div>

          <div className="video-info">
            <div className="video-eyebrow">
              {this.state.currentVideoCategory === 'Video'
                ? 'Video'
                : this.state.currentVideoCategory || category}
            </div>
            <div className="video-hed">
              {this.state.currentVideoTitle
                ? this.state.currentVideoTitle
                : title}
            </div>
            <div className="video-dek">
              {this.state.currentVideoDescription
                ? this.state.currentVideoDescription
                : description}
            </div>
          </div>
        </div>

        {// eslint-disable-next-line react/prop-types
        this.props.endPt && this.renderCustomVideoPlaylist(this.state.video, 1)}

        {!this.props.endPt && (
          <div className="videos">
            {this.state.video.playlist.map(video => (
              <React.Fragment>
                <article
                  key={video.id}
                  className={
                    this.state.currentVideo === video.mediaid ? 'active' : ''
                  }
                  onClick={() =>
                    this.handleVideoSelection(
                      video.mediaid,
                      video.category,
                      video.title,
                      video.description
                    )
                  }
                >
                  <div className="video-thumb">
                    <img src={video.image} alt={video.title} />
                    <img
                      src="//images.fastcompany.net/image/upload/v1602728950/fcweb/play-icon-btn-large_et4asc.svg"
                      alt="play"
                      className="icon"
                    />
                  </div>

                  <div className="video-caption">
                    <span>
                      {video.category === 'Video'
                        ? 'Presented by Facebook'
                        : video.category}
                    </span>
                    <h2>{video.title}</h2>
                  </div>
                </article>
              </React.Fragment>
            ))}
          </div>
        )}
      </section>
    );
  }
}

VideoMegatron.propTypes = {
  playlist: PropTypes.string.isRequired,
  endPt: PropTypes.string
};

VideoMegatron.defaultProps = {
  endPt: ''
};
